<template>
  <a-modal
    :confirm-loading="loading"
    title="群组创建"
    :visible="visible"
    :width="720"
    @cancel="reset"
    @ok="ok"
  >
    <a-form-model
      ref="form"
      :label-col="{
        span: 4,
        style: {
          textAlign: 'left'
        }
      }"
      :model="form"
      :rules="rules"
    >
      <a-form-model-item
        label="群组名称"
        prop="name"
        :wrapper-col="{
          span: 20
        }"
        style="margin-bottom: 0"
      >
        <a-input
          v-model="form.name"
          :max-length="128"
          placeholder="请输入群组名称"
        ></a-input>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: 'CreateModal',
  props: {
    createFunc: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      visible: false,
      form: {
        name: ''
      },
      rules: {
        name: [
          {
            message: '请输入群组名称',
            required: true,
            trigger: 'blur'
          }
        ]
      },
      node: {}
    }
  },
  methods: {
    show (node) {
      this.node = node
      this.visible = true
    },
    reset () {
      this.form = {
        name: ''
      }
      this.$refs.form.resetFields()
      this.visible = false
    },
    ok () {
      this.$refs.form.validate(valid => {
        if (valid) {
          const data = {
            name: this.form.name,
            parent_id: this.node.id
          }
          this.loading = true
          this.createFunc(data)
            .then(res => {
              this.$message.success(res.message)
              this.$emit('ok', this.node.id)
              this.reset()
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>
